import { h } from "preact";
import { observer } from "mobx-react";
import ProductTags from "../../components/ProductTags";
export const SectionItemLabels = (props) => {
    const { tags, freeModifierItemsCount, labelsCreator, availabilitySchedule } = props;
    return (h("div", { className: "m-item__labels" },
        h(ProductTags, { tags: tags, freeModifierItemsCount: freeModifierItemsCount, labelsCreator: labelsCreator, availabilitySchedule: availabilitySchedule })));
};
export default observer(SectionItemLabels);
